import React, { useState, useEffect } from "react"
import { Map, Marker } from "pigeon-maps"
import { Link } from "react-router-dom"
import { estimateGear } from "../../features/TelemetryCalculations"
import { set } from "firebase/database"

export default function LocationMap({ telemetry }) {
    const [carLocations, setCarLocations] = useState({})
    const [mapCentre, setMapCentre] = useState([57.1189133, -2.1351633])
    const [mapZoom, setMapZoom] = useState(15)

    const fixed_color_map = [
        "green",
        "purple",
        "green",
        "orange",
        "purple",
        "pink",
        "yellow",
        "brown",
        "black",
        "gray"
    ]

    function determineCentreOfMap() {
        const cars = Object.values(carLocations)
        if (!cars || cars.length === 0) return [57.1189133, -2.1351633]
        
        let latTotal = 0
        let longTotal = 0
        
        cars.forEach((car) => {
            if (car.location) {
                latTotal += car.location[0]
                longTotal += car.location[1]
            }
        })
        
        const latCentre = latTotal / cars.length
        const longCentre = longTotal / cars.length

        return [latCentre, longCentre]
    }

    const renderMarker = (car, index) => {
        if (!car.location) return null
        
        return <Marker key={index} width={50} anchor={car.location} color={fixed_color_map[index]} />
    }

    const renderCarLegend = (car, index) => {
        return <p key={index} className="btn btn-block" style={{backgroundColor:fixed_color_map[index], color:"white"}}>{car.name}</p>
    }

    function findCarLocations(telemetry) {
        if (!telemetry) return
        
        const newLocations = {}
        
        Object.values(telemetry).forEach((car) => {
            if (!car?.["Lat"] || !car?.["Lon"]) return
            
            const lat = parseFloat(car["Lat"])
            const lon = parseFloat(car["Lon"])
            const name = car["CarName"] || "Unknown"

            newLocations[name] = {
                location: [lat, lon],
                name: name
            }
        })
        
        setCarLocations(newLocations)
    }

    useEffect(() => {
        findCarLocations(telemetry)
    }, [telemetry])

    useEffect(() => {
        setMapCentre(determineCentreOfMap())
    }, [carLocations])

    if (!telemetry) {
        return null
    }

    const carArray = Object.values(carLocations)

    return (
        <div className="card car-summary mb-4">
            <div className="card-header text-center">
                <h3>Map</h3>
            </div>
            <div className="card-body car-summary-vis d-flex flex-column">
                {carArray.length > 0 ? (
                    <>
                        <Map height={300} center={mapCentre} touchEvents={true} mouseEvents={true} defaultZoom={15}>
                            {carArray.map(renderMarker)}
                        </Map>
                        <div className="btn-group w-100">
                            {carArray.map(renderCarLegend)}
                        </div>
                    </>
                ) : (
                    <p className="text-center">No car locations available</p>
                )}
            </div>
        </div>
    )
}